import { render, staticRenderFns } from "./AngularDelegator.vue?vue&type=template&id=f60bb7d4&scoped=true"
import script from "./AngularDelegator.vue?vue&type=script&lang=js"
export * from "./AngularDelegator.vue?vue&type=script&lang=js"
import style0 from "./AngularDelegator.vue?vue&type=style&index=0&id=f60bb7d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60bb7d4",
  null
  
)

export default component.exports